import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, PLATFORM_ID, Inject } from '@angular/core';


import { AppService } from 'src/app/app.service';
import { animations } from './animations';

declare let require: any;
import lottie from 'lottie-web/build/player/lottie.js';
import {CommonModule, NgStyle} from '@angular/common';



@Component({
	standalone: true,
	selector: 'lottie-anim',
	imports: [
		NgStyle
	],
	template: `
		<div #lavContainer
			 [ngStyle]="{'width': viewWidth, 'height': viewHeight, 'overflow':'hidden', 'margin': '0 auto'}">
		</div>`
})
export class LottieAnimationComponent implements OnInit {

	constructor(
		private appService: AppService
	) { }


	@Input() options: any;
	@Input() width: number;
	@Input() height: number;

	@Output() animCreated: any = new EventEmitter();
	@Output() animCmpleted: any = new EventEmitter();

	@ViewChild('lavContainer', { static: true }) lavContainer: ElementRef;

	public viewWidth: string;
	public viewHeight: string;
	private _options: any;
	public currentAnimation;

	ngOnInit() {
		let path = this.options.path || '';

		if (this.options.animationPath) {
			path = `/assets/animations/${this.options.animationPath}.json`;
		}
		if (this.options.animation) {
			this.options.animationData = animations[this.options.animation];
			path = null;
		}
		this._options = {
			container: this.lavContainer.nativeElement,
			renderer: this.options.renderer || 'svg',
			loop: this.options.loop !== false,
			autoplay: this.options.autoplay !== false,
			autoloadSegments: this.options.autoloadSegments !== false,
			animationData: this.options.animationData,
			path: path,
			rendererSettings: this.options.rendererSettings || {}
		};

		this.viewWidth = this.width + 'px' || '100%';
		this.viewHeight = this.height + 'px' || '100%';

		lottie.setLocationHref(document.location.href);

		let anim: any = this.currentAnimation = lottie.loadAnimation(this._options);
		this.animCreated.emit(anim);

		if (this.options.speed) anim.setSpeed(this.options.speed);
		let that = this;
		anim.onComplete = function (o) {
			that.animCmpleted.emit(anim);
		}

		if (this.options.fromTo) {
			anim.playSegments(this.options.fromTo,true)
		}

	}

	playOnce(args) {
		//this.currentAnimation.play();
		this.currentAnimation.playSegments(args, true)
	}

	play() {
		this.currentAnimation.play();
	}
	stop() {
		this.currentAnimation.stop();
	}

}
